import { render } from "./OurProductPage.vue?vue&type=template&id=3b2f3a8d&scoped=true"
import script from "./OurProductPage.vue?vue&type=script&lang=js"
export * from "./OurProductPage.vue?vue&type=script&lang=js"

import "./OurProductPage.vue?vue&type=style&index=0&id=3b2f3a8d&lang=less&scoped=true"
import "./OurProductPage.vue?vue&type=style&index=1&id=3b2f3a8d&lang=less&scoped=true"
import "./OurProductPage.vue?vue&type=style&index=2&id=3b2f3a8d&lang=less&scoped=true"
import "./OurProductPage.vue?vue&type=style&index=3&id=3b2f3a8d&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2f3a8d"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QParallax from 'quasar/src/components/parallax/QParallax.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QParallax,QCard,QCardSection,QBtn,QCarousel,QCarouselSlide,QSeparator});
